import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const SALES_GROUP_VIDEO_REPORT_ID = `sales-group${VIDEO_CAMPAIGN_SUFFIX}`;
